import axiosInstance from "@/api/axios-instance";

// Upload a per-session (step) image to Spaces and return its public CDN url.
// The caller stores the url into the session row (session_types[i].image) and
// persists it via the normal bundle create/update — this only handles bytes.
export async function uploadBundleSessionImage(
  file: File,
): Promise<{ url: string }> {
  const form = new FormData();
  form.append("file", file);
  const r = await axiosInstance.post("/bundle/upload-image", form, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return r.data;
}
